import React from 'react';
import {
    SimpleShowLayout,
    TextField,
    ReferenceField,
} from 'react-admin';
import Box from '@mui/material/Box';

import Show from '../common/views/Show';
import DateField from '../common/fields/DateField';
import StatusField from './fields/StatusField';
import CategoryField from './fields/CategoryField';
import ProgressField from './fields/ProgressField';
import PriorityField from './fields/PriorityField';
import ParticipantsField from './fields/ParticipantsField';
import TaskActionsButtons from './TaskActionsButtons';
import TaskNotes from './TaskNotes';

const TaskShowContent = () => {
    return (
        <Box>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="title" />
                <TextField source="description" multiline />
                <CategoryField source="category" />
                <StatusField source="status" />
                <PriorityField source="priority" />
                <ProgressField source="progress" />
                <ReferenceField label="Owner" source="owner_id" reference="users">
                    <TextField source="fullname" />
                </ReferenceField>
                <ParticipantsField label="Participants" />
                <DateField source="due_date" />
                <DateField source="completed_at" />
                <DateField source="created_at" />
                <DateField source="updated_at" />
            </SimpleShowLayout>
            <Box sx={{ mx: 2 }}>
                <TaskNotes />
            </Box>
        </Box>
    );
};

const TaskShow = props => (
    <Show {...props} actions={<TaskActionsButtons />}>
        <TaskShowContent />
    </Show>
);

export default TaskShow;
